import React from "react";
import { ErrorBlockGeneric } from "common-tailwind-components";
import { useTranslation } from "react-i18next";

import { settingsControlWidth } from "./SettingsControls";

export const SettingsSection = ({
  title,
  description,
  controlSegments,
  children,
}: {
  title: string;
  description?: React.ReactNode;
  controlSegments?: number;
  children: React.ReactNode;
}) => (
  <section className="pb-8">
    <header className={description ? "mb-3" : "mb-2"}>
      <h2 className="text-base font-semibold text-text">{title}</h2>
      {description && <div className="mt-2 text-xs">{description}</div>}
    </header>
    <div
      className="-mx-4 min-w-0 overflow-hidden border-y border-outline bg-surface px-4 sm:mx-0 sm:rounded-lg sm:border sm:px-5"
      style={
        controlSegments === undefined
          ? undefined
          : ({
              "--control-width": settingsControlWidth(controlSegments),
            } as React.CSSProperties)
      }
    >
      {children}
    </div>
  </section>
);

export const SettingsRow = ({
  title,
  description,
  alignTop = false,
  children,
}: {
  title: string;
  description?: string;
  alignTop?: boolean;
  children: React.ReactNode;
}) => (
  <div
    className={`grid gap-3 py-4 sm:grid-cols-[minmax(0,1fr)_auto] sm:gap-6 ${
      alignTop ? "sm:items-start" : "sm:items-center"
    }`}
  >
    <div className="min-w-0">
      <h3 className="text-sm font-medium text-text">{title}</h3>
      {description && <p className="mt-1 text-xs leading-5 text-text-mid">{description}</p>}
    </div>
    <div className="min-w-0">{children}</div>
  </div>
);

/** Row body shown while a setting's current value is still loading, or failed to. */
export const SettingsLoadState = ({ error }: { error: string | null }) => {
  const { t } = useTranslation();
  return (
    <div className="text-xs text-text-mid">
      {error ? <ErrorBlockGeneric error={error} /> : t("loading_ellipsis")}
    </div>
  );
};
